export var covid_dates = ['01-24', '01-25', '01-26', '01-27', '01-28', '01-29', '01-30',
    '01-31', '02-01', '02-02', '02-03', '02-04', '02-05', '02-06',
    '02-07', '02-08', '02-09', '02-10', '02-11', '02-12', '02-13',
    '02-14', '02-15', '02-16', '02-17', '02-18', '02-19', '02-20',
    '02-21', '02-22', '02-23', '02-24', '02-25', '02-26', '02-27',
    '02-28', '02-29', '03-01', '03-02', '03-03', '03-04', '03-05',
    '03-06', '03-07', '03-08', '03-09', '03-10', '03-11', '03-12',
    '03-13', '03-14', '03-15', '03-16', '03-17', '03-18', '03-19',
    '03-20', '03-21', '03-22', '03-23', '03-24', '03-25', '03-26',
    '03-27', '03-28', '03-29', '03-30', '03-31', '04-01', '04-02',
    '04-03', '04-04', '04-05', '04-06', '04-07', '04-08', '04-09',
    '04-10', '04-11', '04-12', '04-13', '04-14', '04-15', '04-16',
    '04-17', '04-18', '04-19', '04-20', '04-21', '04-22', '04-23',
    '04-24', '04-25', '04-26', '04-27']
export var sars_dates = ['03-31-2003', '04-02-2003', '04-06-2003', '04-09-2003',
'04-15-2003', '04-18-2003', '04-21-2003', '04-22-2003',
'04-23-2003', '04-24-2003', '04-26-2003', '04-27-2003',
'04-28-2003', '04-29-2003', '04-30-2003', '05-01-2003',
'05-02-2003', '05-03-2003', '05-04-2003', '05-05-2003',
'05-06-2003', '05-07-2003', '05-08-2003', '05-09-2003',
'05-10-2003', '05-11-2003', '05-12-2003', '05-13-2003',
'05-14-2003', '05-15-2003', '05-16-2003', '05-17-2003',
'05-18-2003', '05-19-2003', '05-20-2003', '05-21-2003',
'05-22-2003', '05-23-2003', '05-24-2003', '05-25-2003',
'05-26-2003', '05-27-2003', '05-28-2003', '05-29-2003',
'05-30-2003', '05-31-2003', '06-01-2003', '06-02-2003',
'06-03-2003', '06-04-2003', '06-05-2003', '06-06-2003',
'06-07-2003', '06-08-2003', '06-09-2003', '06-10-2003',
'06-11-2003', '06-12-2003', '06-13-2003', '06-14-2003',
'06-15-2003', '06-16-2003', '06-17-2003', '06-18-2003',
'06-19-2003', '06-20-2003', '06-21-2003', '06-22-2003',
'06-23-2003', '06-24-2003', '06-25-2003', '06-26-2003',
'06-28-2003', '06-29-2003', '06-30-2003', '07-02-2003',
'07-04-2003', '07-05-2003', '07-08-2003', '07-10-2003',
'07-12-2003', '07-13-2003', '07-15-2003', '07-16-2003',
'07-17-2003', '07-27-2003', '07-30-2003', '08-02-2003',
'08-13-2003', '08-14-2003', '08-15-2003', '08-16-2003']